import { ToastaService } from 'ngx-toasta';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

import { createAction, props, Store } from '@ngrx/store';
import { EsAuthor } from '../../core/models/EsAuthor';


export class AuthenticationActionConstantAction {

    static readonly LOAD_AUTH_START = 'LOAD_AUTH_START';
    static readonly LOAD_AUTH_SUCCEEDED = 'LOAD_AUTH_SUCCEEDED';
    static readonly LOAD_AUTH_FAILED = 'LOAD_AUTH_FAILED';

    static readonly LOAD_DELEGANT_SUCCEED = '[AUTHENTICATION].LOAD_DELEGANT_SUCCEEDED';
    static readonly REMOVE_DELEGANT_SUCCEED = '[AUTHENTICATION].REMOVE_DELEGANT_SUCCEED';

    static readonly LOGOUT_SUCCEEDED = 'LOGOUT_SUCCEEDED';
    static readonly LOGOUT_FAILED = 'LOGOUT_FAILED';
}

export const loadAuthStart= createAction(AuthenticationActionConstantAction.LOAD_AUTH_START);
export const loadAuthSucceeded= createAction(AuthenticationActionConstantAction.LOAD_AUTH_SUCCEEDED, props<{role: any}>());
export const loadAuthFailed= createAction(AuthenticationActionConstantAction.LOAD_AUTH_FAILED, props<{error: Error}>());

export const loadDelegantSucceedAction = createAction(AuthenticationActionConstantAction.LOAD_DELEGANT_SUCCEED, props<{payload: EsAuthor}>());
export const removeDelegantSucceedAction = createAction(AuthenticationActionConstantAction.REMOVE_DELEGANT_SUCCEED);

export const logoutAuthSucceeded= createAction(AuthenticationActionConstantAction.LOGOUT_SUCCEEDED);
export const logoutAuthFailed= createAction(AuthenticationActionConstantAction.LOGOUT_FAILED, props<{error: Error}>() );

@Injectable({
  providedIn: 'root',
})
export class AuthenticationAction {


  constructor(
    private translateService: TranslateService,
    private toastaService: ToastaService,
    private store: Store
  ) {
  }

  public loadAuthenticationStart(): void {
    this.store.dispatch({
      type: AuthenticationActionConstantAction.LOAD_AUTH_START
    });
  }

  public loadAuthenticationSucceeded(): void {
    this.store.dispatch({
      type: AuthenticationActionConstantAction.LOAD_AUTH_SUCCEEDED,
      payload: { role: undefined }
    });
  }

  public loadAuthenticationFailed(error: any) {
    this.store.dispatch({
      type: AuthenticationActionConstantAction.LOAD_AUTH_FAILED,
      error: error
    });
    this.toastaService.error(this.translateService.instant('TOASTER_MESSAGES.ERROR'));
  }

  public logoutSucceeded(): void {
    this.store.dispatch({
      type: AuthenticationActionConstantAction.LOGOUT_SUCCEEDED
    });
  }

    loadDelegantSucceed( payload: EsAuthor ) {
        this.store.dispatch(loadDelegantSucceedAction({payload}));
    }

    removeDelegantSucceed(): void {
        this.store.dispatch(removeDelegantSucceedAction());
    }
}
